<button *ngIf="!disabled" (click)="items?.length ? open() : newItem();" class="btn btn-sm btn-default mt-2">{{(items?.length ? openListButtonLabel : 'New') | translate}}</button>

<drawer [title]="title" [isClosed]="isClosed" (closeEvent)="closeLayer()" [showHeaderButtons]="multiselect ? true : false" (cancelEvent)="closeLayer()" (saveEvent)="saveSelectedItems()" [noContentPadding]="true">
	<div class="row d-flex align-items-center py-1 list-search-container-zone">
		<div class="col">
            <div class="list-search-container pe-1">
                <i class="fas fa-search list-search-icon"></i>
                    <input type="text"
						(click)="$event.stopPropagation()"
						(input)="filterChanged($event.target.value)"
						[(ngModel)]="filterText"
						placeholder="{{ 'Search' | translate }}"
						class="form-control list-search-input flex-grow-1">
						<i
                        *ngIf="filterText"
                        (click)="clearFilter()"
                        class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"
                        aria-hidden="true"
                      ></i>
					  <!--
                      <a *ngIf="multiselect" class="btn btn-sm btn-default"
                            placement="left"
                            (click)="selectAll();"
                            aria-hidden="true">
                            <i class="fal {{selectedItems?.length === items?.length ? 'fa-check': 'fa-square'}} mr-1"></i>
                            {{(selectedItems?.length === items?.length ? 'Deselect all' : 'Select all') | translate}}</a>
			-->
					<toggle-switch *ngIf="multiselect" [labelPosition]="'left'" [label]="(selectedItems?.length === items?.length ? 'Deselect all' : 'Select all') | translate"
						[containerClass]="'bg-white py-1 px-2'" [toggled]="selectedItems?.length === items?.length ? true : false" (toggledChange)="selectAll();"></toggle-switch>
						<button class="btn btn-sm btn-primary ml-1"
						placement="left"
						*ngIf="showAddButton"
                        (click)="newItem();"
						aria-hidden="true">{{'New' | translate}}</button>
            </div>
        </div>
	</div>
	<div class="list-search-options-zone">
		<div *ngIf="!items || !items.length" class="d-flex justify-content-center my-5">
			<i class="fad fa-spinner-third fa-spin align-self-center fa-2x"></i>
		</div>
		<div *ngIf="items && items.length" class="expanded-list row px-3 pb-0">
			<div class="col px-4 list-item-container">
				<div *ngFor="let item of items | serviceFilter: filterContent; let i = index" class="item py-2 row">
					<div class="col-8 col-lg-9 d-flex align-items-center" (click)="multiselect ? selectMultipleItem(item) : selectItem(item);">
						<span>{{item.name || item.label || item.text}}</span>
					</div>
					<div class="col-4 col-lg-3 text-right">
                        <!--<i *ngIf="multiselect" class="fal {{isSelectedMultiple(item) ? 'fa-check' : 'fa-square'}} btn-xs btn-outline-primary btn-icon mr-2" 
                            (click)="selectMultipleItem(item);$event.stopPropagation();"></i>
					-->
						<toggle-switch *ngIf="multiselect" [containerClass]="'toggle-switch-no-label'" [toggled]="isSelectedMultiple(item)" (toggledChange)="selectMultipleItem(item);"></toggle-switch>
						<i *ngIf="showEditButton" class="fas fa-pencil btn-xs btn-outline-primary btn-icon item-remove ml-2"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</drawer>